import BasePage from "../../../base/BasePage";
import React from "react";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
import CommendationPresenter from "./CommendationPresenter";
import CardView from "../../../components/common/CardView";
import RegionTab from "../../../components/common/RegionTab";
import ListOfEmployeePage from "./CommendationTable/ListOfEmployeePage";
import LogsPage from "./CommendationTable/LogsPage";

class CommendationPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new CommendationPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "List of Employee", content: <ListOfEmployeePage /> },
      { title: "Logs", content: <LogsPage /> },
    ];

    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Merit Reward and Recognition &gt;{" "}
              <span style={{ color: "#333" }}>Commendation</span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default CommendationPage;
